import { useState } from "react";
import { axiosInstance } from "lib/axios";
import { authAPI } from "services/apis.service";
import { UserInfoService } from "features/User";

export const useUserProfile = (user) => {
  const [error, setError] = useState(null);
  const userInfoService = new UserInfoService(axiosInstance);

  const getUserDetails = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${authAPI.getUserDetails}?userId=${user.userId}`,
        {
          cache: false
        }
      );
      return data;
    } catch (e) {
      setError(e.response?.data || e.message);
      throw e;
    }
  };

  const checkUniqueUsername = async (username) => {
    if (!username.length) {
      const err = "Username cannot be empty.";
      setError(err);
      throw new Error(err);
    }
    try {
      // If the user exists, include userId in the query
      userInfoService.checkUniqueUsername(username, user);
      return true;
    } catch (e) {
      throw e;
    }
  };

  const updateProfile = async (username, setErrorText) => {
    try {
      const formData = new FormData();
      formData.append("UserId", user.userId);
      formData.append("UserName", username);
      const { data } = await userInfoService.updateProfile(formData);
      return data;
    } catch (e) {
      console.error(e);
       const errorMessage =
         e?.response?.data ||
         e?.response?.data?.message ||
         "An unexpected error occurred.";
       setErrorText(errorMessage);;
      throw e;
    }
  };

  return { getUserDetails, checkUniqueUsername, updateProfile, error };
};
